export const blobToDataURL = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
    
        reader.onload = () => {
            resolve(reader.result as string);
        };
    
        reader.onerror = reject;
    
        reader.readAsDataURL(blob);
      });
}

export const blobToObjectURL = (blob: Blob) : string => {
    return window.URL.createObjectURL(blob);
}